const PATH = {
    home: '/',
    thankYou: '/thank-you',
};

export default PATH;
